var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconTwitter = function SvgIconTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.704 2.547a5.596 5.596 0 0 0 1.607-.441 5.692 5.692 0 0 1-1.396 1.449c.005.12.008.24.008.362 0 3.699-2.816 7.964-7.966 7.964a7.925 7.925 0 0 1-4.292-1.258A5.617 5.617 0 0 0 4.81 9.464a2.803 2.803 0 0 1-2.615-1.943 2.826 2.826 0 0 0 1.264-.048 2.802 2.802 0 0 1-2.246-2.78c.378.21.81.335 1.268.35a2.797 2.797 0 0 1-.866-3.737 7.949 7.949 0 0 0 5.77 2.925 2.8 2.8 0 0 1 4.77-2.553 5.608 5.608 0 0 0 1.78-.68 2.81 2.81 0 0 1-1.231 1.549Z",
    fill: "#fff"
  })));
};

export { SvgIconTwitter as ReactComponent };
export default __webpack_public_path__ + "6b7d147b55beb44ce0f9ce4b612cb0a1.svg";